import comp from "./LinkWithTooltip";
export default comp;
